@if (layout === 'engagement') {
  <div class="bg-lBlack light:bg-lGray950 border border-lGray800 rounded-2xl p-5 h-full flex flex-col gap-3 min-h-0">
    <div class="flex items-center gap-3 min-w-0">
      @if (showIcon) {
        <span class="w-9 h-9 rounded-xl bg-lGray700 flex items-center justify-center shrink-0">
          <l-icon class="text-lWhite text-lg leading-none">{{ metric.icon }}</l-icon>
        </span>
      }
      <p
        class="text-color text-base font-semibold leading-snug truncate min-w-0"
        [title]="metric.title"
      >{{ metric.title }}</p>
    </div>

    <div class="flex items-center justify-center gap-2 flex-1 min-h-0">
      <l-dashboard-donut-chart [metric]="metric" variant="full" [size]="chartSize" />
      <l-dashboard-trend-list [trends]="metric.trends" variant="compact" />
    </div>
  </div>

} @else {
  <div class="h-full min-h-[12.5rem] flex flex-col">
    <p
      class="text-color text-base font-semibold leading-snug mb-2 truncate"
      [title]="metric.title"
    >{{ metric.title }}</p>

    <div class="grid grid-cols-[1fr_auto] gap-3 items-end flex-1">
      <l-dashboard-donut-chart [metric]="metric" variant="semi" [size]="chartSize" />
      <l-dashboard-trend-list [trends]="metric.trends" variant="compact" />
    </div>
  </div>
}
